import Vue from 'vue'
import Vuex from 'vuex'
import { axiosInit, getAndAnalysisData } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    index: 0,
    isLoading: true,
    HasError: null,
    isShowTop: true,
    isShowBottom: false,
    isShowPage: {
      StuInfo: false,
      Schedule: false,
      Morning: false,
      Select: false,
      Rewards: false,
      Library: false,
      Card: false,
    },
    $data: {
      data: {
        _sort:[],
        room:0,
        lead:{
          first:"",
          timePoint:"",
          timeBefore:"",
          count:"",
        },
        seat:{
          count:0,
          last:{
            time:"",
            at:""
          },
          first:{
            timePoint:"",
            timeBefore:"",
            at:"",
            // where:"",
          }
        }
      },
    },
  },
  mutations: {
    writeData(state, payload) {
      state.$data = payload.data
    },
    LoadingDone(state) {
      state.isLoading = false
    },
    showTop(state) {
      state.isShowTop = true
    },
    hideTop(state) {
      state.isShowTop = false
    },
    showBottom(state) {
      state.isShowBottom = true
    },
    hideBottom(state) {
      state.isShowBottom = false
    },
    //判断哪些页面时有数据的，可以展示的
    changeShowPage(state, payload) {
      for (let item of payload.sort) {
        state.isShowPage[item] = true
      }
    },
    errorHappened(state, payload) {
      console.log(payload)
      state.HasError = payload.error
    },
    changeIndex(state, payload) {
      state.index = payload.num
    },
  },
  actions: {
    async init() {
      await axiosInit()
      await getAndAnalysisData()
    },
  },
  modules: {},
})
